import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { isPayBy, openBotimOAuth } from 'utils'
import { Toast } from 'antd-mobile'
import { oauthByAuthCode } from 'store/siteConfig'

// ------------------------------------
// Constants
// ------------------------------------
export const REWARD_GREEN_POINT = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    VERIFY_AND_RECEIVE_REQUEST: null,
    VERIFY_AND_RECEIVE_SUCCESS: null,
    SET_IS_PAYBY: null,
    SET_GP_INFO: null,
    SHOW_PAGE: null
  },
  'REWARD_GREEN_POINT'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  const { lotteryOrder, isBotim, ...resData } = data // 根据url是否带订单号判断来源，无lotterOrder为分享红包
  return dispatch => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: lotteryOrder
          ? 'cgs/marketing/lottery'
          : 'cgs/marketing/share/lottery',
        body: {
          lotteryOrder,
          ...resData
        },
        method: 'POST',
        requestAction: REWARD_GREEN_POINT.INIT_REQUEST,
        successAction: REWARD_GREEN_POINT.INIT_SUCCESS,
        success: function(result) {
          if (isBotim) {
            // botim新版本自动关注公众号
            openBotimOAuth('oaSubscribe,userInfoDetail', data => {
              dispatch(oauthByAuthCode({ authCode: data }))
            })
          }
          dispatch(showPage())
        },
        error: function(result, msg) {
          dispatch(handleError(result.head))
          dispatch(showPage())
        }
      })
    )
  }
}

export function verifyAndReceive(data) {
  return (dispatch, getState) => {
    const { ticket, token } = getState().siteConfig
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/marketing/registerAndLottery',
        body: {
          ...data,
          ticket,
          token
        },
        method: 'POST',
        requestAction: REWARD_GREEN_POINT.VERIFY_AND_RECEIVE_REQUEST,
        successAction: REWARD_GREEN_POINT.VERIFY_AND_RECEIVE_SUCCESS,
        success: function(result) {
          dispatch(setIsPayBy(true))
        },
        error: function(result, msg) {
          if (result.head.code === '70420') {
            dispatch(setIsPayBy(true))
            dispatch(handleError(result.head))
          } else {
            Toast.info(msg)
          }
        }
      })
    )
  }
}

export function handleError(data) {
  const { msg, code } = data
  return dispatch => {
    dispatch({
      type: REWARD_GREEN_POINT.INIT_SUCCESS,
      payload: {
        msg: code === '70420' ? "You've received PayBy Cash Gift" : msg // 区分已领取和其他报错
      }
    })
  }
}

export function setIsPayBy(data) {
  return {
    type: REWARD_GREEN_POINT.SET_IS_PAYBY,
    payload: {
      isPayBy: data
    }
  }
}

export function setGpInfo() {
  return dispatch => {
    dispatch({
      type: REWARD_GREEN_POINT.SET_GP_INFO,
      payload: JSON.parse(sessionStorage.getItem('gpInfo'))
    })
  }
}

export function showPage() {
  return {
    type: REWARD_GREEN_POINT.SHOW_PAGE
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [REWARD_GREEN_POINT.INIT_REQUEST]: (state, action) => state,
  [REWARD_GREEN_POINT.INIT_SUCCESS]: (state, action) => {
    // 分享或查看协议回来会重新获取接口，所以先缓存数据，避免重复调用
    const data = Object.assign({}, state, action.payload)
    sessionStorage.setItem('gpInfo', JSON.stringify(data))
    return data
  },
  [REWARD_GREEN_POINT.VERIFY_AND_RECEIVE_REQUEST]: (state, action) => state,
  [REWARD_GREEN_POINT.VERIFY_AND_RECEIVE_SUCCESS]: (state, action) => {
    const data = Object.assign({}, state, action.payload)
    sessionStorage.setItem('gpInfo', JSON.stringify(data))
    return data
  },
  [REWARD_GREEN_POINT.SET_IS_PAYBY]: (state, action) =>
    Object.assign({}, state, action.payload),
  [REWARD_GREEN_POINT.SET_GP_INFO]: (state, action) =>
    Object.assign({}, state, action.payload),
  [REWARD_GREEN_POINT.SHOW_PAGE]: (state, action) =>
    Object.assign({ showPage: true }, state, action.payload)
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isPayBy: isPayBy(),
  eventUrl: 'https://s.payby.com/p/yQjANn'
}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'rewardGreenPoint',
    reducerMap: {
      rewardGreenPointState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
